import type { GetExploreItemsResponse } from './types'
import { baseUri, getOptions } from '../utils'

import request from 'api/requestUtils'
import { onlyDefinedProperties } from 'lib/object/objectUtils'

const endpointUri = `${baseUri}/v2/explore`

export type ExploreParams = {
  query: string
  locationBias: [number, number]
  /** Type of place to search for, as per https://developers.google.com/maps/documentation/places/web-service/place-types */
  type?: string
}

export async function getExploreItems(
  params: ExploreParams,
  accessToken?: string,
): Promise<GetExploreItemsResponse['result']> {
  const queryParams = new URLSearchParams(
    onlyDefinedProperties({
      query: params.query,
      locationBias: params.locationBias.join(','),
      type: params.type as string,
    }),
  )
  const uri = `${endpointUri}?${queryParams.toString()}`
  return request
    .get<GetExploreItemsResponse>(uri, getOptions(accessToken))
    .then((response) => response.result)
}
